module.exports = __webpack_public_path__ + "img/help-icon.e33f443d.svg";